"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxHoverStyle = exports.StyledCheckbox = exports.Input = exports.CheckedIcon = exports.Checkbox = exports.CHECKBOX_STYLES = void 0;
exports.getCheckboxDisabledStyles = getCheckboxDisabledStyles;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _animations = require("../../styles/animations");
var _variables = require("../../styles/variables");
var _mixins = require("../../styles/mixins");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CHECKBOX_STYLES = exports.CHECKBOX_STYLES = {
  checked: {
    on: {
      background: "".concat(_colors["default"].neutral900),
      borderColor: "".concat(_colors["default"].neutral900)
    },
    off: {
      background: "".concat(_colors["default"].white),
      borderColor: "".concat(_colors["default"].neutral600)
    }
  },
  xs: {
    width: '16px',
    height: '16px'
  },
  sm: {
    width: '20px',
    height: '20px'
  },
  md: {
    width: '24px',
    height: '24px'
  },
  lg: {
    width: '24px',
    height: '24px'
  },
  xl: {
    width: '24px',
    height: '24px'
  }
};
function getCheckboxDisabledStyles(_ref) {
  var $isActive = _ref.$isActive,
    customTheme = _ref.customTheme;
  var color = $isActive ? (customTheme === null || customTheme === void 0 ? void 0 : customTheme.background) || _colors["default"].neutral900 : _colors["default"].neutral200;
  return (0, _styledComponents.css)(["&&{pointer-events:none;opacity:", ";border-color:", ";background:", ";box-shadow:none;}"], $isActive ? 0.2 : 1, color, color);
}
function getCustomTheme(_ref2) {
  var background = _ref2.background;
  return (0, _styledComponents.css)(["background:", ";border-color:", ";"], background, background);
}
var checkboxHoverStyle = exports.checkboxHoverStyle = (0, _styledComponents.css)(["outline:none;border-color:", ";"], _colors["default"].neutral900);
var Input = exports.Input = _styledComponents["default"].input.withConfig({
  displayName: "HBCheckboxstyles__Input",
  componentId: "sc-8y6n0n-0"
})(["cursor:pointer;appearance:none !important;margin:0 !important;overflow:hidden;&:focus,&:hover{", "}border-radius:inherit;border-width:1px;border-style:solid;box-sizing:border-box;", " ", " ", " ", " ", ""], function (props) {
  return props.hideFocusAndHoverStyles ? null : checkboxHoverStyle;
}, (0, _styledIs.isNot)('$isActive')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), _variables.BOX_SHADOW.checkbox["default"]), (0, _styledIs.isNot)('customTheme')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), function (props) {
  return props.$isActive ? CHECKBOX_STYLES.checked.on : CHECKBOX_STYLES.checked.off;
}), (0, _styledIs["default"])('customTheme')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), function (props) {
  return props.$isActive ? getCustomTheme(props.customTheme) : CHECKBOX_STYLES.checked.off;
}), (0, _styledIs["default"])('disabled')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), getCheckboxDisabledStyles), (0, _mixins.focusState)());
var Checkbox = exports.Checkbox = _styledComponents["default"].div.withConfig({
  displayName: "HBCheckboxstyles__Checkbox",
  componentId: "sc-8y6n0n-1"
})(["display:inline-flex;align-items:center;", " &,*{border-radius:2px;", ";}", " ", ""], function (props) {
  return props.isDisabled && 'pointer-events: none;';
}, function (props) {
  return CHECKBOX_STYLES[props.size];
}, function (props) {
  return props.$margin && (0, _styledComponents.css)(["margin:", ";"], props.$margin);
}, _mixins.hideInPrint);
var StyledCheckbox = exports.StyledCheckbox = _styledComponents["default"].span.withConfig({
  displayName: "HBCheckboxstyles__StyledCheckbox",
  componentId: "sc-8y6n0n-2"
})(["position:relative;", ""], _mixins.inlineFlexCenterAll);
var CheckedIcon = exports.CheckedIcon = _styledComponents["default"].span.withConfig({
  displayName: "HBCheckboxstyles__CheckedIcon",
  componentId: "sc-8y6n0n-3"
})(["pointer-events:none;position:absolute;", ";opacity:", ";", " ", " i{", "}"], _animations.transition.apply(void 0, ['all'].concat((0, _toConsumableArray2["default"])(_variables.hoverEase))), function (props) {
  return props.$isActive ? 1 : 0;
}, _mixins.inlineFlexCenterAll, (0, _styledIs.isNot)('isDisabled')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        ", "\n    "])), _variables.BOX_SHADOW.checkbox.checked), _mixins.inlineFlexCenterAll);
//# sourceMappingURL=HBCheckbox.styles.js.map